
export default function Hero() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.85), rgba(255, 255, 255, 0.85)), url('https://public.readdy.ai/ai/img_res/e0fab6b5bd86f3954c5cc0ec51ebc1e2.jpg')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-6 py-20">
        <div className="max-w-2xl">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-800 mb-6 leading-tight">
            心に寄り添う<br />
            遺品整理・生前整理
          </h1>
          <p className="text-xl text-gray-700 mb-8 leading-relaxed">
            大切な思い出を丁寧に整理いたします。<br />
            ご家族の気持ちに寄り添い、誠実に対応させていただきます。
          </p>
          
          <div className="grid grid-cols-2 gap-4 mb-10">
            <div className="flex items-center gap-2 bg-white/90 px-4 py-3 rounded-lg shadow-sm">
              <i className="ri-time-line text-2xl text-green-600 w-8 h-8 flex items-center justify-center"></i>
              <span className="text-gray-800 font-medium whitespace-nowrap">最短即日対応</span>
            </div>
            <div className="flex items-center gap-2 bg-white/90 px-4 py-3 rounded-lg shadow-sm">
              <i className="ri-money-dollar-circle-line text-2xl text-green-600 w-8 h-8 flex items-center justify-center"></i>
              <span className="text-gray-800 font-medium whitespace-nowrap">無料お見積り</span>
            </div>
            <div className="flex items-center gap-2 bg-white/90 px-4 py-3 rounded-lg shadow-sm">
              <i className="ri-user-smile-line text-2xl text-green-600 w-8 h-8 flex items-center justify-center"></i>
              <span className="text-gray-800 font-medium whitespace-nowrap">女性スタッフ対応可</span>
            </div>
            <div className="flex items-center gap-2 bg-white/90 px-4 py-3 rounded-lg shadow-sm">
              <i className="ri-shield-check-line text-2xl text-green-600 w-8 h-8 flex items-center justify-center"></i>
              <span className="text-gray-800 font-medium whitespace-nowrap">秘密厳守</span>
            </div>
          </div>

          <p className="text-sm text-gray-600">
            受付時間：8:00〜20:00（年中無休）
          </p>
        </div>
      </div>
    </section>
  );
}
